export default "__VITE_ASSET__D9BCYS7R__"